<template>
    <div>
        <vs-card title="Background Pick" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Background Pick</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Production ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Movement ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Movement Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-button type="border" :disabled="selected.length < 1" @click="removeLine" class="mb-5">Remove</vs-button>
            <vs-table v-model="selected" :data="details" stripe multiple>
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="tr">
                        {{ tr.line_id }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.product_code }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.description_1 }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.pack_id }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.batch }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.expired_date }}
                    </vs-td>
                    
                    <vs-td :data="tr">
                        {{ tr.base_qty}}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.base_uom_name }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.stock_type_name }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.location_type }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.location_code }}
                    </vs-td>

                    <vs-td :data="tr">
                        {{ tr.storage_unit }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    data() {
        return {
            data: {},
            selected: [],
            isLoading: false,
            details: []
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        fetchData() {
            this.isLoading = true
            this.$http.get('valueaddedservice/productionorder/getpickpartition/' + this.$route.params.id)
            .then(res => {
                this.isLoading = false
                this.data = res.data
                this.details = res.data.details
                this.data.movement_date = new Date()
                this.generateLineId()
            })
            .catch(() => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchData()
                    },
                    cancel: () => this.$router.push({ name: 'production-order-view', params: {id: this.$route.params.id} }),
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
        },
        back() {
            this.$router.push({ name: 'production-order-view', params: {id: this.$route.params.id} })
        },
        submitForm() {
            let error = false

            const details = []

            if(this.data.details.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Picking line is empty'
                })
                return false
            }

            this.data.details.map(item => {
                if(!item.location_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + '. No location assigned'
                    })

                    error = true
                }
                else {
                    details.push(item.draft_id)
                }
            })

            if(error) {
                return false
            }
            else {
                this.isLoading = true

                const dataSend = {
                    id: this.$route.params.id,
                    movement_date: this.data.movement_date,
                    details: details
                }

                this.$http.post('valueaddedservice/productionorder/storepick', dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.$router.push({ name: 'production-order-view', params: {id: this.$route.params.id} })
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            }
        },
        removeLine() {
            let indexes = []
            this.selected.map(selected => {
                this.data.details.map((detail, index) => {
                    if(selected.line_id == detail.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.data.details.splice(i, 1))
            this.selected = []
            this.generateLineId()
        },
        generateLineId() {
            this.data.details.map((item, index) => item.line_id = index + 1)
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>